import React, { useState, useRef, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import api from "../services/api"; //  ADD
import useAuth from "../context/AuthContext";
import ThemeToggle from "./ThemeToggle";
import { useTheme } from "../context/ThemeContext";

import logoDark from "../assets/Logo.png";
import logoLight from "../assets/itax-whiite.png";
import dashboardDark from "../assets/Dashboard.png";
import dashboardLight from "../assets/Dashboard-white.png";
import itaxQuestDark from "../assets/iTaxQuest.png";
import itaxQuestLight from "../assets/iTaxQuest-White.png";
import itaxCompDark from "../assets/iTaxComp.png";
import itaxCompLight from "../assets/iTaxComp-white.png";
import feedbackDark from "../assets/Feedback.png";
import feedbackLight from "../assets/Feedback-white.png";
import notificationDark from "../assets/Notifications.png";
import notificationLight from "../assets/Notification-white.png";
import adminAvatar from "../assets/Adminavatar.jpg";
import logoutDark from "../assets/logout.avif";
import logoutLight from "../assets/logout-white.avif";

interface SidebarProps {
  activeKey?: "dashboard" | "itaxquest" | "eci" | "formc" | "feedback" | "notifications";
  
}

export default function Sidebar({ activeKey = "dashboard" }: SidebarProps) {
  const navigate = useNavigate();

  const [openCompMenu, setOpenCompMenu] = useState(
    activeKey === "eci" || activeKey === "formc"
  );

  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const menuRef = useRef<HTMLDivElement | null>(null);
  const { user } = useAuth();
  const location = useLocation();
  const [showDashboardConfirm, setShowDashboardConfirm] = useState(false);
  const { theme } = useTheme();


  useEffect(() => {
    function onDocClick(e: MouseEvent) {
      if (!menuRef.current) return;
      if (!menuRef.current.contains(e.target as Node)) {
        setOpenCompMenu(false);
      }
    }
    document.addEventListener("mousedown", onDocClick);
    return () => document.removeEventListener("mousedown", onDocClick);
  }, []);


useEffect(() => {
  const checkMobile = () => {
    setIsMobile(window.innerWidth <= 1024);
  };

  checkMobile();
  window.addEventListener("resize", checkMobile);
  return () => window.removeEventListener("resize", checkMobile);
}, []);


  /* ================================
     START NEW ECI (KEY FIX)
     ================================ */
  const handleStartEci = async () => {
    try {
      const res = await api.post("/engagement", {
        clientId: 1,            //  TEMP (same as current system)
        yearOfAssessment: 2026,
        formType: "ECI",
      });

      const engagementId = res.data?.data?.id;

      if (!engagementId) {
        throw new Error("Engagement ID not returned");
      }

      navigate(`/eci/${engagementId}`);
    } catch (err) {
      console.error("Failed to start ECI", err);
      alert("Unable to start ECI. Please try again.");
    }
  };

  const handleStartFormC = async () => {
  try {
    const res = await api.post("/engagement", {
      clientId: 1,
      yearOfAssessment: 2026,
      formType: "FORM_C",
    });

    const engagementId = res.data?.data?.id;

    if (!engagementId) {
      throw new Error("Engagement ID not returned");
    }

    navigate(`/formc/${engagementId}`);
  } catch (err) {
    console.error("Failed to start Form C", err);
    alert("Unable to start Form C. Please try again.");
  }
};
const dashboardPath =
  user?.role === "approver" ? "/approver" : "/preparer";

const isOnDashboard = location.pathname === dashboardPath;
const handleLogoClick = () => {
  //  Do NOT show popup if already on dashboard
  if (isOnDashboard) {
    return;
  }

  //  Keep existing popup behavior everywhere else
  setShowDashboardConfirm(true);
};



const confirmRedirectToDashboard = () => {
  setShowDashboardConfirm(false);

  if (user?.role === "approver") {
    navigate("/approver");
  } else {
    // default to preparer
    navigate("/preparer");
  }
};

const cancelRedirect = () => {
  setShowDashboardConfirm(false);
};

  const navItemStyle = (active: boolean): React.CSSProperties => ({
    padding: "12px 16px",
    borderRadius: 10,
    display: "flex",
    alignItems: "center",
    gap: 12,
    cursor: "pointer",
    fontSize: 14,
    fontWeight: active ? 600 : 500,
    color: active ? "#60a5fa" : "var(--color)",
    background: active ?"var(--bg-color)" : "transparent",
  });

  const iconStyle: React.CSSProperties = {
    width: 16,
    height: 16,
    objectFit: "contain",
    flex: "0 0 16px",
  };

  return (
<>

    {isMobile && !sidebarOpen && (
  <button
    onClick={() => setSidebarOpen(true)}
    style={{
      position: "fixed",
      top: 20,
      left: 20,
      zIndex: 9999,
      background: "var(--step-connector)",
      border: "none",
      borderRadius: 8,
      padding: "10px 14px",
      fontSize: 22,
      cursor: "pointer",
    }}
  >
    ☰
  </button>
  )}

    <aside
        style={{
    width: 240,
    background: "var(--bg-color)",
    borderRight: "1px solid var(--border)",
    padding: 24,
    display: "flex",
    flexDirection: "column",
    minHeight: "100vh",
    position: "fixed",
    top: 0,
    left: isMobile
      ? sidebarOpen
        ? 0
        : -260
      : 0,
    transition: "left 0.3s ease",
    zIndex: 5000,
  }}
>

  {isMobile && (
  <button
    onClick={() => setSidebarOpen(false)}
    style={{
      alignSelf: "flex-end",
      background: "var(--step-connector)",
      border: "none",
      fontSize: 22,
      cursor: "pointer",
      marginBottom: 10,
    }}
  >
    ✕
  </button>
)}
 

 {/* THEME TOGGLE — top-right corner */}
      <div style={{ position: "absolute", top: 20, right: 66, zIndex: 10 }}>
        <ThemeToggle />
      </div>

      {/* TOP */}

      <div>
        {/* LOGO */}
        <div style={{ marginBottom: 80 }}>
          <img
             src={theme === "dark" ? logoDark : logoLight}
            alt="logo"
            style={{ height: 40, width: 99, cursor: "pointer",objectFit: "contain" }}
            onClick={handleLogoClick}
          />

        </div>


        {/* NAV */}
        <nav style={{ display: "flex", flexDirection: "column", gap: 8 }}>
          <div
            style={navItemStyle(activeKey === "dashboard")}
            onClick={() => {
                  navigate("/preparer");
                  if (isMobile) setSidebarOpen(false);
                          }}
          >
            <img
            src={theme === "dark" ? dashboardDark : dashboardLight}
            style={iconStyle}
          />
            Dashboard
          </div>

          <div
            style={navItemStyle(activeKey === "itaxquest")}
           onClick={() => {
                  navigate("/itaxquest");
                  if (isMobile) setSidebarOpen(false);
                          }}
          >
           <img
            src={theme === "dark" ? itaxQuestDark : itaxQuestLight}
            style={iconStyle}
          />      
                iTaxQuest
          </div>  

          {/* iTaxComp */}
          <div ref={menuRef}>
            <div
              style={navItemStyle(activeKey === "eci" || activeKey === "formc")}
              onClick={() => setOpenCompMenu((v) => !v)}
            >
              <img  src={theme === "dark" ? itaxCompDark : itaxCompLight}
            style={iconStyle} />
              iTaxComp
              <span style={{ marginLeft: "auto" }}>
                {openCompMenu ? "▾" : "▸"}
              </span>
            </div>

            {openCompMenu && (
              <div
                style={{
                  marginLeft: 28,
                  marginTop: 6,
                  display: "flex",
                  flexDirection: "column",
                  gap: 4,
                }}
              >
                {/* FIXED ECI */}
                <div
                  onClick={handleStartEci}
                  style={{
                    padding: "8px 12px",
                    borderRadius: 8,
                    fontSize: 13,
                    cursor: "pointer",
                    color: "var(--color)",

                  }}
                >
                  ECI
                </div>

                <div
onClick={handleStartFormC}                  
style={{
                    padding: "8px 12px",
                    borderRadius: 8,
                    fontSize: 13,
                    cursor: "pointer",
                    color:
                      activeKey === "formc" ? "#60a5fa" : "var(--color)",
                  }}
                >
                  Form C / C-S / C-S (Lite)
                </div>
              </div>
            )}
          </div>

          <div
            style={navItemStyle(activeKey === "feedback")}
           onClick={() => {
                  navigate("/feedback");
                  if (isMobile) setSidebarOpen(false);
                          }}
          >
            <img  src={theme === "dark" ? feedbackDark : feedbackLight}
            style={iconStyle} />
            Feedback
          </div>
        </nav>
      </div>


          <div
            style={navItemStyle(activeKey === "notifications")}
           onClick={() => {
                  navigate("/notifications");
                  if (isMobile) setSidebarOpen(false);
                          }}
          >
            <img src={theme === "dark" ? notificationDark : notificationLight} style={iconStyle} />
            Notifications
          </div>



      {/* USER CARD */}
      <div
        style={{
          width: 150,
          height: 234,
          borderRadius: 20,
          background: "var(--page-gradient)",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "20px 12px",
          alignSelf: "center",
          marginTop: "auto",
          marginBottom: "24px",
        }}
      >
        <img src={adminAvatar} style={{ width: 52, height: 52 }} alt="Admin Avatar" />
        <div style={{ textAlign: "center" }}>
          <div style={{ color: "var(--color)", fontWeight: 600 }}>Admin</div>
          <div style={{ fontSize: 12, color: "var(--color)" }}>
            enquiry@itax.sg
          </div>
        </div>

        <button
         onClick={() => {
  navigate("/login");
  if (isMobile) setSidebarOpen(false);
}}
          style={{
            width: 54,
            height: 54,
            borderRadius: "100%",
            border: "1px solid var(--border)",
            background: "transparent",
          }}
        >
          <img src={theme === "dark" ? logoutDark : logoutLight} style={{ width: 28, height: 28 }} alt="Logout" />
        </button>
      </div>
      {showDashboardConfirm && (
  <div
    onClick={cancelRedirect}
    style={{
      position: "fixed",
      inset: 0,
      background: "var(--bg-color)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 2000,
    }}
  >
    
    <div
      onClick={(e) => e.stopPropagation()}
      style={{
        width: 420,
        height: 200,
        background: "var(--bg-color)",
        borderRadius: 16,
        padding: 28,
        alignContent: "center",
        textAlign: "center",
        boxShadow: "var(--shadow-elevated)"
      }}
    >
      <div
        style={{
          color: "var(--color)",
          fontSize: 16,
          fontWeight: 600,
          marginBottom: 24,
        }}
      >
        You will be redirected to your dashboard.  
        Do you want to continue?
      </div>

      <div style={{ display: "flex", justifyContent: "center", gap: 16 }}>
        <button
          onClick={confirmRedirectToDashboard}
          style={{
            padding: "10px 22px",
            borderRadius: 999,
            background: "var(--page-gradient)",
            border: "none",
            color: "var(--color)",
            fontWeight: 600,
            cursor: "pointer",
          }}
        >
          Yes
        </button>

        <button
          onClick={cancelRedirect}
          style={{
            padding: "10px 22px",
            borderRadius: 999,
            background: "transparent",
            border: "1px solid var(--border)",
            color: "var(--color)",
            cursor: "pointer",
          }}
        >
          No
        </button>
      </div>
    </div>
  </div>
)}

    </aside>
</>
  );
}